import { render, staticRenderFns } from "./ImportNotifications.vue?vue&type=template&id=9f49002e&scoped=true"
import script from "./ImportNotifications.vue?vue&type=script&lang=js"
export * from "./ImportNotifications.vue?vue&type=script&lang=js"
import style0 from "./ImportNotifications.vue?vue&type=style&index=0&id=9f49002e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f49002e",
  null
  
)

export default component.exports